import { FilterField } from "~/features/filter";

import { useFileUsersOptions } from "./optionsHooks";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы файлов ПКД. Имена полей совпадают с URL-параметрами,
 * которые использовали старый поиск по названию и PKDFilterForm, —
 * они же источник query-переменных каталога файлов.
 */
export const pkdFilesFilterFields = (t: Translate): FilterField[] => [
  {
    name: "searchText",
    type: "input",
    label: t("pkd.filter_by_name"),
  },
  {
    name: "UserId",
    type: "select",
    label: t("pkd.UserId"),
    optionsHook: useFileUsersOptions,
  },
  {
    name: "dateBegin",
    nameTo: "dateEnd",
    type: "dateRange",
    label: t("pkd.period"),
    placeholder: t("ui.from"),
    placeholderTo: t("ui.to"),
  },
];
